import React from 'react';

function Text({ children, ...props }: React.AnchorHTMLAttributes<HTMLAnchorElement>) {
  return (
    <a {...props} className="hover:underline focus:underline">
      {children}
    </a>
  );
}

function BodyText({ children, ...props }: React.AnchorHTMLAttributes<HTMLAnchorElement>) {
  return (
    <a {...props} className="hover:underline focus:underline text-content-brand visited:text-purple-600">
      {children}
    </a>
  );
}

export const A = {
  Text,
  BodyText,
};
